<template>
  <v-col cols="12">
    <v-row key="row-customer-phone">
      <v-col cols="6" class="pa-0 pb-2 pr-1">
        <v-text-field
          v-model="copyOfForm.customer"
          v-validate="required.customer"
          :label="mess['dialog_request_field_customer']"
          :error-messages="errors.collect('customer')"
          outlined
          dense
          data-vv-name="customer"
        />
      </v-col>

      <v-col cols="6" class="pa-0 pb-2 pl-1">
        <v-text-field
          v-model="copyOfForm.phone"
          v-validate="required.phone"
          :label="mess['dialog_request_field_phone']"
          :error-messages="errors.collect('phone')"
          outlined
          dense
          data-vv-name="phone"
        />
      </v-col>
    </v-row>

    <v-row key="row-request_form-product_group">
      <v-col cols="6" class="pa-0 pb-2 pr-1">
        <v-select
          v-model="copyOfForm.request_form"
          v-validate="required.request_form"
          :items="requestForms"
          :label="mess['dialog_request_field_request_form']"
          :error-messages="errors.collect('request_form')"
          return-object
          item-text="title"
          outlined
          dense
          data-vv-name="request_form"
        />
      </v-col>

      <v-col
        v-if="process && process.product_group"
        key="col-product_group"
        cols="6"
        class="pa-0 pb-2 pl-1"
      >
        <v-select
          v-model="copyOfForm.service_engineer"
          v-validate="required.service_engineer"
          :items="serviceEngineer"
          :label="mess['dialog_request_field_service_engineer']"
          :error-messages="errors.collect('service_engineer')"
          return-object
          item-text="title"
          outlined
          dense
          data-vv-name="service_engineer"
        />
      </v-col>
    </v-row>

    <v-row key="row-date-1">
      <v-col cols="4" class="pa-0 pb-2 pr-3">
        <v-menu
          v-model="dateOfPurchase.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          @input="dateOfPurchase.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfPurchase"
              v-on="on"
              :label="mess['dialog_request_field_date_of_purchase']"
              prepend-icon="event"
              readonly
              outlined
              dense
              class="request-datepicker-text-field"
            />
          </template>

          <v-date-picker
            v-model="dateOfPurchase.date"
            no-title
            scrollable
          >
            <v-spacer />

            <v-btn
              text
              color="primary"
              @click="dateOfPurchase.close(false)"
            >
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn
              text
              color="primary"
              @click="dateOfPurchase.save"
            >
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="4" class="pa-0 pb-2 pr-3">
        <v-text-field
          v-model="copyOfForm.bill_num"
          v-validate="required.bill_num"
          :label="mess['dialog_request_field_bill_num']"
          :error-messages="errors.collect('bill_num')"
          outlined
          dense
          data-vv-name="bill_num"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2">
        <v-menu
          v-model="dateOfBill.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          @input="dateOfBill.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfBill"
              v-on="on"
              :label="mess['dialog_request_field_date_of_bill']"
              prepend-icon="event"
              readonly
              outlined
              dense
              class="request-datepicker-text-field"
            />
          </template>

          <v-date-picker
            v-model="dateOfBill.date"
            no-title
            scrollable
          >
            <v-spacer/>

            <v-btn
              text
              color="primary"
              @click="dateOfBill.close(false)"
            >
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn
              text
              color="primary"
              @click="dateOfBill.save"
            >
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-row key="row-date-2">
      <v-col cols="6" class="pa-0 pb-2 pr-3">
        <v-menu
          v-model="dateOfReceipt.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          @input="dateOfReceipt.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfReceipt"
              v-on="on"
              :label="mess['dialog_request_field_date_of_receipt']"
              prepend-icon="event"
              readonly
              outlined
              dense
              class="request-datepicker-text-field"
            />
          </template>

          <v-date-picker
            v-model="dateOfReceipt.date"
            no-title
            scrollable
          >
            <v-spacer />

            <v-btn
              text
              color="primary"
              @click="dateOfReceipt.close(false)"
            >
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn
              text
              color="primary"
              @click="dateOfReceipt.save"
            >
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="6" class="pa-0 pb-2">
        <v-menu
          v-model="dateOfCommissioning.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          @input="dateOfCommissioning.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfCommissioning"
              v-on="on"
              :label="mess['dialog_request_field_date_of_commissioning']"
              class="request-datepicker-text-field"
              prepend-icon="event"
              readonly
              outlined
              dense
            />
          </template>

          <v-date-picker
            v-model="dateOfCommissioning.date"
            no-title
            scrollable
          >
            <v-spacer />

            <v-btn
              text
              color="primary"
              @click="dateOfCommissioning.close(false)"
            >
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn
              text
              color="primary"
              @click="dateOfCommissioning.save"
            >
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-row key="row-date-3">
      <v-col cols="6" class="pa-0 pb-2 pr-3">
        <v-menu
          v-model="dateOfIncident.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          @input="dateOfIncident.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfIncident"
              v-on="on"
              :label="mess['dialog_request_field_date_of_incident']"
              class="request-datepicker-text-field"
              prepend-icon="event"
              readonly
              outlined
              dense
            />
          </template>

          <v-date-picker
            v-model="dateOfIncident.date"
            no-title
            scrollable
          >
            <v-spacer />

            <v-btn
              text
              color="primary"
              @click="dateOfIncident.close(false)"
            >
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn
              text
              color="primary"
              @click="dateOfIncident.save"
            >
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="6" class="pa-0 pb-2">
        <v-menu
          v-model="dateOfRequest.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          @input="dateOfRequest.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfRequest"
              v-on="on"
              :label="mess['dialog_request_field_date_of_request']"
              prepend-icon="event"
              readonly
              outlined
              dense
              class="request-datepicker-text-field"
            />
          </template>

          <v-date-picker
            v-model="dateOfRequest.date"
            no-title
            scrollable
          >
            <v-spacer />

            <v-btn
              text
              color="primary"
              @click="dateOfRequest.close(false)"
            >
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn
              text
              color="primary"
              @click="dateOfRequest.save"
            >
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-row key="row-request_reason">
      <v-col cols="12" class="pa-0 pb-2">
        <v-select
          v-model="copyOfForm.request_reason"
          v-validate="required.request_reason"
          :items="requestReasons"
          :label="mess['dialog_request_field_request_reason']"
          :error-messages="errors.collect('request_reason')"
          return-object
          item-text="title"
          outlined
          dense
          data-vv-name="request_reason"
        />
      </v-col>
    </v-row>

    <v-row key="row-incident_description">
      <v-col cols="12" class="pa-0 pb-2">
        <v-textarea
          v-model="copyOfForm.incident_description"
          v-validate="required.incident_description"
          :label="mess['dialog_request_field_incident_description']"
          :error-messages="errors.collect('incident_description')"
          outlined
          dense
          data-vv-name="incident_description"
        />
      </v-col>
    </v-row>

    <v-row key="row-articles">
      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-combobox
          v-model="copyOfForm.article_element"
          v-validate="required.article_element"
          :items="searchedElementArticles"
          :search-input.sync="searchElementArticle"
          :label="mess['dialog_request_field_article_element']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          :error-messages="errors.collect('article_element')"
          color="primary"
          outlined
          dense
          item-text="pdm_elementid"
          data-vv-name="article_element"
          @update:search-input="
            onUpdateArticleSearchInput(
              'searchedElementArticles',
              'by_element_id',
              $event
            )
          "
          @change="
            onChangeArticle('searchElementArticle', 'article_element', $event)
          "
        >
          <template #item="{ item }">
            <span style="font-size: 12px">
              <b>{{ item.pdm_elementid }}</b>
              {{ item.pdm_oemarticle }}
            </span>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-combobox
          v-model="copyOfForm.article_original"
          v-validate="required.article_original"
          :items="searchedElementArticles"
          :search-input.sync="searchOriginalArticle"
          :label="mess['dialog_request_field_article_original']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          :error-messages="errors.collect('article_original')"
          color="primary"
          outlined
          dense
          item-text="pdm_oemarticle"
          data-vv-name="article_original"
          @update:search-input="
            onUpdateArticleSearchInput(
              'searchedElementArticles',
              'by_oem_id',
              $event
            )
          "
          @change="
            onChangeArticle('searchOriginalArticle', 'article_original', $event)
          "
        >
          <template #item="{ item }">
            <span style="font-size: 12px">
              {{ item.pdm_elementid }}
              <b>{{ item.pdm_oemarticle }}</b>
            </span>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="4" class="pa-0 pb-2">
        <v-text-field
          v-model="copyOfForm.po_n"
          v-validate="required.po_n"
          :label="mess['dialog_request_field_po_n']"
          :error-messages="errors.collect('po_n')"
          outlined
          dense
          data-vv-name="po_n"
        />
      </v-col>
    </v-row>

    <v-row key="row-equipment">
      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-combobox
          v-model="copyOfForm.equipment"
          v-validate="required.equipment"
          :items="equipments"
          :label="mess['dialog_request_field_equipment']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          :error-messages="errors.collect('equipment')"
          color="primary"
          outlined
          dense
          hide-no-data
          data-vv-name="equipment"
          @update:search-input="onUpdateEquipmentSearchInput($event)"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-text-field
          v-model="copyOfForm.serial_number"
          v-validate="required.serial_number"
          :label="mess['dialog_request_field_serial_number']"
          :error-messages="errors.collect('serial_number')"
          outlined
          dense
          data-vv-name="serial_number"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2">
        <v-select
          v-model="copyOfForm.year"
          v-validate="required.year"
          :items="years"
          :label="mess['dialog_request_field_year']"
          :error-messages="errors.collect('year')"
          type="number"
          outlined
          dense
          data-vv-name="year"
        />
      </v-col>
    </v-row>

    <v-row
      key="row-damage_1"
      :class="[
        'fields-group',
        { 'fields-group--active': isThereDamage }
      ]"
    >
      <v-col cols="12" class="pa-0 pb-2">
        <v-select
          v-model="copyOfForm.damage_1"
          v-validate="required.damage_1"
          :items="damages"
          :label="mess['dialog_request_field_damage_1_']"
          :error-messages="errors.collect('damage_1')"
          return-object
          item-text="title"
          outlined
          dense
          data-vv-name="damage_1"
        />
      </v-col>
    </v-row>

    <v-row
      v-if="isThereDamage"
      key="row-articles_additional"
      class="fields-group fields-group--active"
    >
      <v-col cols="12" class="pa-0 pb-2">
        <v-combobox
          v-model="copyOfForm.articles"
          :items="searchedAdditionalArticles"
          :search-input.sync="searchAdditionalArticle"
          :label="mess['dialog_request_field_articles']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          multiple
          color="primary"
          outlined
          dense
          chips
          deletable-chips
          item-text="pdm_elementid"
          item-value="id"
          @update:search-input="
            onUpdateArticleSearchInput(
              'searchedAdditionalArticles',
              'by_element_id',
              $event
            )
          "
          @change="
            onChangeArticle('searchAdditionalArticle', 'articles', $event)
          "
        />
      </v-col>
    </v-row>

    <v-row
      v-if="isThereDamage"
      key="row-damage_description"
      class="fields-group fields-group--active mb-2"
    >
      <v-col cols="12" class="pa-0">
        <v-textarea
          v-model="copyOfForm.damage_description"
          v-validate="required.damage_description"
          :label="mess['dialog_request_field_damage_description']"
          :error-messages="errors.collect('damage_description')"
          outlined
          dense
          data-vv-name="damage_description"
        />
      </v-col>
    </v-row>

    <v-row key="row-customer_requirements">
      <v-col cols="12" class="pa-0 pb-2">
        <v-textarea
          v-model="copyOfForm.customer_requirements"
          v-validate="required.customer_requirements"
          :label="mess['dialog_request_field_customer_requirements']"
          :error-messages="errors.collect('customer_requirements')"
          outlined
          dense
          data-vv-name="customer_requirements"
        />
      </v-col>
    </v-row>

    <v-row key="row-optime" class="align-center">
      <v-col cols="6" class="pa-0 pb-2 pr-3">
        <v-text-field
          v-model.number="copyOfForm.optime_plan"
          v-validate="required.optime_plan"
          :label="`${mess['dialog_request_field_optime_plan']}, ${optimeUnit}`"
          :error-messages="errors.collect('optime_plan')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="optime_plan"
        />
      </v-col>

      <v-col cols="6" class="pa-0 pb-2">
        <v-text-field
          v-model.number="copyOfForm.optime_actual"
          v-validate="required.optime_actual"
          :label="
            `${mess['dialog_request_field_optime_actual']}, ${optimeUnit}`
          "
          :error-messages="errors.collect('optime_actual')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="optime_actual"
        />
      </v-col>
    </v-row>

    <v-row key="row-params-1">
      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_1"
          v-validate="required.shs_param_1"
          :label="mess['dialog_request_field_shs_param_1']"
          :error-messages="errors.collect('shs_param_1')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="shs_param_1"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_2"
          v-validate="required.shs_param_2"
          :label="mess['dialog_request_field_shs_param_2']"
          :error-messages="errors.collect('shs_param_2')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="shs_param_2"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_3"
          v-validate="required.shs_param_3"
          :label="mess['dialog_request_field_shs_param_3']"
          :error-messages="errors.collect('shs_param_3')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="shs_param_3"
        />
      </v-col>
    </v-row>

    <v-row key="row-params-2">
      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_4"
          v-validate="required.shs_param_4"
          :label="mess['dialog_request_field_shs_param_4']"
          :error-messages="errors.collect('shs_param_4')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="shs_param_4"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_5"
          v-validate="required.shs_param_5"
          :label="mess['dialog_request_field_shs_param_5']"
          :error-messages="errors.collect('shs_param_5')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="shs_param_5"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_6"
          v-validate="required.shs_param_6"
          :label="mess['dialog_request_field_shs_param_6']"
          :error-messages="errors.collect('shs_param_6')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="shs_param_6"
        />
      </v-col>
    </v-row>

    <v-row key="row-params-3">
      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_7"
          v-validate="required.shs_param_7"
          :label="mess['dialog_request_field_shs_param_7']"
          :error-messages="errors.collect('shs_param_7')"
          type="text"
          min="0"
          outlined
          dense
          data-vv-name="shs_param_7"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_8"
          v-validate="required.shs_param_8"
          :label="mess['dialog_request_field_shs_param_8']"
          :error-messages="errors.collect('shs_param_8')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="shs_param_8"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_9"
          v-validate="required.shs_param_9"
          :label="mess['dialog_request_field_shs_param_9']"
          :error-messages="errors.collect('shs_param_9')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="shs_param_9"
        />
      </v-col>
    </v-row>

    <v-row key="row-params-4">
      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_10"
          v-validate="required.shs_param_10"
          :label="mess['dialog_request_field_shs_param_10']"
          :error-messages="errors.collect('shs_param_10')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="shs_param_10"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_11"
          v-validate="required.shs_param_11"
          type="number"
          min="0"
          outlined
          dense
          :label="mess['dialog_request_field_shs_param_11']"
          :error-messages="errors.collect('shs_param_11')"
          data-vv-name="shs_param_11"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2">
        <v-text-field
          v-model.number="copyOfForm.shs_param_12"
          v-validate="required.shs_param_12"
          type="number"
          min="0"
          outlined
          dense
          :label="mess['dialog_request_field_shs_param_12']"
          :error-messages="errors.collect('shs_param_12')"
          data-vv-name="shs_param_12"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import getArticles from "@/mixins/GetArticles";
import getEquipments from "@/mixins/GetEquipments";
import isNumber from "lodash/isNumber";
import RequestForm from "@/mixins/RequestForm";

/**
 * @memberOf RequestDialog
 * @name HydrotransportForm
 * @desc Компонент для отрисовки формы "Гидротранспорт"
 *
 * @vue-prop { Object } process - Текущий процесс.
 *
 * @vue-data { Object } [copyOfForm={}] - Данные из полей записываются в эту переменную.
 * @vue-data { requestDialogDatePicker } dateOfBill - Объект отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 * @vue-data { requestDialogDatePicker } dateOfCommissioning - Объект отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 * @vue-data { requestDialogDatePicker } dateOfIncident - Объект отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 * @vue-data { requestDialogDatePicker } dateOfPurchase - Объект отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 * @vue-data { requestDialogDatePicker } dateOfReceipt - Объект отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 * @vue-data { requestDialogDatePicker } dateOfRequest - Объект отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 * @vue-data { String | null } [searchAdditionalArticle=null] - Тут хранится введенный в строку поиска element-артикула текст (для полей поиска артикула которые показываются при разборка аналога = да).
 * @vue-data { String | null } [searchElementArticle=null] - Тут хранится введенный в строку поиска element-артикула текст.
 * @vue-data { String | null } [searchOriginalArticle=null] - Тут хранится введенный в строку поиска артикула текст (для полей поиска артикула которые показываются при разборка аналога = да).
 * @vue-data { Array } [searchedAdditionalArticles=[]] - Тут хранится результат поиска по артикулам на основе текста из searchArticleAdditional.
 * @vue-data { Array } [searchedElementArticles=[]] - Тут хранится результат поиска по element-артикулам.
 *
 * @vue-computed { String } currentDate - Текущая дата.
 * @vue-computed { Object } damages - Возвращает варианты для select-а "Повреждение сопряженных деталей".
 * @vue-computed { Boolean } isCustomUnit - Проверяет выбрана ли ед измерения custom.
 * @vue-computed { Boolean } isThereDamage - Проверят значение в поле "Повреждение сопряженных деталей" для отрисовки доп полей,
 * если вернет true.
 * @vue-computed { String } optimePercent - Возвращает процент рассчитанный на основе optime_actual и optime_plan
 * @vue-computed { String } optimeUnit - Возвращает текст в зависимости от выбранной ед измерения
 * @vue-computed { Object[] } requestForms - Возвращает массив элементов для select-a "Форма запроса".
 * @vue-computed { Object[] } requestReasons - Возвращает массив элементов для select-a "Причина обращения".
 * @vue-computed { Object[] } serviceEngineer - Возвращает массив элементов для select-a "Выезд сервисного инжеренра".
 * @vue-computed { String[] } years - Возвращает массив дат.
 *
 * @vue-event initDefaultDates - Метод для проставления текущей даты всем объектам используемым для отрисовки datePicker.
 * Это нужно для того чтобы datePicker не был пустым при открытии поп-апа.
 */
export default {
  name: "HydrotransportForm",
  inject: ["$validator"],
  mixins: [getArticles, getEquipments, RequestForm],
  props: {
    process: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      copyOfForm: {},
      dateOfBill: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfBill.isOpen = false;
            this.dateOfBill.date = this.copyOfForm.dateOfBill;
          }
        },
        save: () => {
          this.copyOfForm.dateOfBill = this.dateOfBill.date;
          this.dateOfBill.close();
        }
      },
      dateOfCommissioning: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfCommissioning.isOpen = false;
            this.dateOfCommissioning.date = this.copyOfForm.dateOfCommissioning;
          }
        },
        save: () => {
          this.copyOfForm.dateOfCommissioning = this.dateOfCommissioning.date;
          this.dateOfCommissioning.close();
        }
      },
      dateOfIncident: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfIncident.isOpen = false;
            this.dateOfIncident.date = this.copyOfForm.dateOfIncident;
          }
        },
        save: () => {
          this.copyOfForm.dateOfIncident = this.dateOfIncident.date;
          this.dateOfIncident.close();
        }
      },
      dateOfPurchase: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfPurchase.isOpen = false;
            this.dateOfPurchase.date = this.copyOfForm.dateOfPurchase;
          }
        },
        save: () => {
          this.copyOfForm.dateOfPurchase = this.dateOfPurchase.date;
          this.dateOfPurchase.close();
        }
      },
      dateOfReceipt: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfReceipt.isOpen = false;
            this.dateOfReceipt.date = this.copyOfForm.dateOfReceipt;
          }
        },
        save: () => {
          this.copyOfForm.dateOfReceipt = this.dateOfReceipt.date;
          this.dateOfReceipt.close();
        }
      },
      dateOfRequest: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfRequest.isOpen = false;
            this.dateOfRequest.date = this.copyOfForm.dateOfRequest;
          }
        },
        save: () => {
          this.copyOfForm.dateOfRequest = this.dateOfRequest.date;
          this.dateOfRequest.close();
        }
      },
      searchAdditionalArticle: null,
      searchElementArticle: null,
      searchOriginalArticle: null,
      searchedAdditionalArticles: [],
      searchedElementArticles: []
    };
  },
  computed: {
    currentDate() {
      return new Date().toISOString().substr(0, 10);
    },
    damages() {
      return this.process?.params?.damage || [];
    },
    errors() {
      return {};
    },
    isCustomUnit() {
      return this.copyOfForm?.optime_unit === "custom";
    },
    isThereDamage() {
      return parseInt(this.copyOfForm.damage_1?.id) === 1;
    },
    optimePercent() {
      const {
        optime_actual: actual = null,
        optime_plan: plan = null
      } = this.copyOfForm;

      if (!isNumber(actual) || !isNumber(plan)) return (0).toFixed(2) + "%";
      if (actual < 0 || plan <= 0) return (0).toFixed(2) + "%";
      return ((actual / plan) * 100).toFixed(2) + "%";
    },
    optimeUnit() {
      return this.mess["dialog_request_button_units_hours"];
    },
    requestForms() {
      return this.process?.params?.request_form || [];
    },
    requestReasons() {
      return this.process?.params?.request_reason || [];
    },
    serviceEngineer() {
      return this.process?.params?.service_engineer || [];
    },
    years() {
      return [...Array(100).keys()].map(
        elem => new Date().getFullYear() - elem
      );
    }
  },
  mounted() {
    this.initDefaultDates();
  },
  methods: {
    initDefaultDates() {
      this.copyOfForm.dateOfBill = this.currentDate;
      this.copyOfForm.dateOfCommissioning = this.currentDate;
      this.copyOfForm.dateOfIncident = this.currentDate;
      this.copyOfForm.dateOfPurchase = this.currentDate;
      this.copyOfForm.dateOfReceipt = this.currentDate;
      this.copyOfForm.dateOfRequest = this.currentDate;
    }
  }
};
</script>
